import { ARG_PREFIX_NUMBER, CORRECT_CHARACTER } from '../constants/telephones/phonePrefixes';

export const FormatPhone = (telephone) => {
    const argentinePhonePrefix = telephone?.substr(0, 4) === ARG_PREFIX_NUMBER;

    if (!argentinePhonePrefix) {
        telephone = `${ARG_PREFIX_NUMBER}${telephone}`;
    }
    const isCharacteristicWrong = telephone.substr(4, 3) === '011';

    if (isCharacteristicWrong) {
        telephone = telephone.slice(0, 4) + CORRECT_CHARACTER + telephone.slice(7);
    }
    return telephone;
};
